/**
 * ShopPad Infinite Options - gemeinsame EN-Uebersetzungs-Maps (Single Source).
 *
 * Genutzt von:
 *   - option-i18n.js         -> uebersetzt die PDP-Labels (Swatches + Gruppen-Ueberschriften)
 *   - product-form.js        -> uebersetzt die Line-Item-Properties beim Add-to-Cart
 *                               (EN-Storefront), damit Warenkorb UND Checkout englisch sind
 *
 * Nur Daten + reine Uebersetzungsfunktionen, KEIN DOM-Zugriff. Global via window.SPOptionI18n.
 * Erweitern: neue Optionsnamen in LABELS, neue Farben/Auswahlwerte in COLORS ergaenzen.
 * Bewusst NICHT gelistet (bleiben unveraendert): M-Line, Red Line, Race, DE, Orange,
 * Knit-Black sowie Freitext-Kundeneingaben.
 */
(function () {
  'use strict';

  // Sichtbare Labels: Option-Gruppen-Ueberschriften (PDP) + Property-Keys (Cart/Checkout).
  var LABELS = {
    'Strebenfarbe': 'Bar Color',
    'Netzfarbe': 'Net Color',
    'Nahtfarbe': 'Seam Color',
    'inkl. MwSt.': 'Tax included.',
    'Wunschfarbe': 'Custom color',
    'Wunschfarbe der Naht angeben': 'Specify custom seam color',
    'Sonderton': 'Custom shade',
    'Sonderton (als Nachricht angeben)': 'Custom shade (please specify)',
    'Wunschfarbe (als Nachricht angeben)': 'Custom color (please specify)',
    '3/5 Türer': '3/5-door',
    '4Motion / Frontantrieb': '4Motion / Front-wheel drive',
    'Quattro / Frontantrieb': 'Quattro / Front-wheel drive',
    'Frontantrieb': 'Front-wheel drive',
    '3 Tür': '3-door',
    '5 Tür': '5-door',
  };

  // Auswahlwerte DE -> EN. Preis-Suffix "(+ X €)" bleibt via translateValue erhalten.
  var COLORS = {
    'Schwarz glanz': 'Gloss Black',
    'Schwarz matt': 'Matte Black',
    'Vollcarbon': 'Full Carbon',
    'Vollcarbon matt': 'Full Carbon matte',
    'Daytona grau': 'Daytona Grey',
    'Neongelb': 'Neon Yellow',
    'Neongrün': 'Neon Green',
    'Sonderton': 'Custom shade',
    'Marineblau': 'Navy Blue',
    'Olivgrün': 'Olive Green',
    'Royalrot': 'Royal Red',
    'Royal Lila': 'Royal Purple',
    'Aqua Blau': 'Aqua Blue',
    'Blattgrün': 'Leaf Green',
    'Knit-Braun': 'Knit Brown',
    'Knit-Grün': 'Knit Green',
    'Knit-Rosa': 'Knit Pink',
    'Knit-Blau': 'Knit Blue',
    'Knit-Gelb': 'Knit Yellow',
    'Knit-Rot': 'Knit Red',
    'Knit-Weiß': 'Knit White',
    'Knit-Schwarz': 'Knit Black',
    'Elfenbein': 'Ivory',
    'Turbogelb': 'Turbo Yellow',
    'Acid Gelb': 'Acid Yellow',
    'Teal Grau': 'Teal Grey',
    'Schoko': 'Chocolate',
    'Seofoam': 'Seafoam',
    'Schwarz': 'Black',
    'Weiß': 'White',
    'Rot': 'Red',
    'Blau': 'Blue',
    'Gelb': 'Yellow',
    'Violett': 'Purple',
    'Grün': 'Green',
    'Rosa': 'Pink',
    'Grau': 'Grey',
    'Limette': 'Lime',
    'Farbe wie das Netz': 'Same as net',
    'Wunschfarbe': 'Custom color',
    // Cart-Ergaenzungen: Property-Werte, die NICHT als Swatch-Label auftreten
    'Standard Schwarz': 'Standard Black',
    '1 individuelle Nahtfarbe': '1 individual seam color',
    'Sonderton (als Nachricht angeben)': 'Custom shade (please specify)',
    'Wunschfarbe (als Nachricht angeben)': 'Custom color (please specify)',
    '5 Tür': '5-door',
    'Frontantrieb': 'Front-wheel drive',
    '3 Tür': '3-door',
  };

  // Trennt einen Preis-Suffix "(+ X €)" vom Namen ab.
  function splitSuffix(text) {
    var m = text.match(/^([\s\S]*?)(\s*\(\+[^)]*\))?\s*$/);
    return { name: (m && m[1] ? m[1] : text).trim(), suffix: (m && m[2]) ? m[2] : '' };
  }

  // Uebersetzt einen Auswahlwert (Suffix bleibt). null wenn unbekannt (Aufrufer behaelt Original).
  function translateValue(text) {
    var p = splitSuffix(text);
    return COLORS[p.name] ? (COLORS[p.name] + p.suffix) : null;
  }

  // Uebersetzt einen Optionsnamen/Property-Key. Nummerisches Praefix "N. " bleibt erhalten.
  // null wenn unbekannt (Aufrufer behaelt Original).
  function translateLabel(key) {
    var m = key.match(/^(\d+\.\s*)([\s\S]+)$/);
    var prefix = m ? m[1] : '';
    var base = m ? m[2] : key;
    return LABELS[base] ? (prefix + LABELS[base]) : null;
  }

  window.SPOptionI18n = {
    LABELS: LABELS,
    COLORS: COLORS,
    translateValue: translateValue,
    translateLabel: translateLabel,
  };
})();
